export default __webpack_public_path__ + "static/media/Intro_BGM.bdc3cf70.wav";